<template>
    <div class="layout">
      <img src="./assets/bg1.png" alt="">
      <div class="companyName">翱捷数据中台</div>
      <div class="loginBox">
        <h4>登陆页面</h4>
        <div class="loginForm">
          <div class="top">用户名登录</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="用户名" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入账号" ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="ruleForm.password" placeholder="请输入密码" ></el-input>
            </el-form-item>
          </el-form>
          <div class="bottom">
             <el-button type="primary" @click="clickEle">登录</el-button>
          </div>
        </div>
      </div>
      <div class="bottom">
        <a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2020092254号-4</a>
      </div>
    </div>
</template>

<script>
  export default{
    data(){
      return{
        ruleForm:{
          name:"",
          password:''
        },
        rules:{
          name:[
            {required: true, message: '用户名不能为空', trigger: 'blur'},
            ],
          password:[
            {required: true, message: '密码不能为空', trigger: 'blur'},
          ]  
        }
      }
    },
    methods:{
      clickEle(){
        setTimeout(function () {
        window.alert("账号密码错误")
        clearTimeout();	//清除定时器
        }, 1000);
      }
    }
  }
</script>

<style lang="less" scoped>
@import './assets/css/initialize.css';
  .layout{
    width: 100%;
    height: 100%;
    .companyName{
      position: absolute;
      top: 30px;
      left: 44px;
      color: #fff;
      font-weight: 700;
      font-size: 30px;
    }
    img{
      position:absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .loginBox{
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      width:450px;
      height: 300px;
      border:5px solid #d8ebff57;
      z-index: 1; 
      overflow: hidden;
      position: absolute;
      top: 20%;
      right: 200px;
      padding-top: 25px;
      h4{
        color: #fff;
        font-size: 24px;
      }
      .loginForm{
        height: 332px;
        width: 360px;
        display: flex;
        flex-direction: column;
        justify-content: start;
        .top{
          margin-bottom: 25px;
          color: #409EFF;
          font-size: 14px;
          font-weight: 500;
        }
        /deep/ .el-input{
          display: block;
          margin-bottom: 10px;
        }
        .bottom{
          padding: 0;
          display: flex;
          justify-content: start;
          /deep/ .el-button{
            border: 0;
            padding: 0;
            width: 80%;
            height: 50%;
          }
        }
      }
    }
        .bottom{
          position: absolute;
          bottom: 0;
          text-align: center;
          height: 60px;
          width: 100%;
        }
  }
</style>
